const WARNING_LIMIT = 0.8;

const CLASS_OK = 'is-ok';
const CLASS_WARNING = 'is-warning';
const CLASS_DANGER = 'is-danger';

const InputCount = {
  /**
   * Create count element
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node, props) {
    // Find the label in the component
    this.label = document.getElementById(props.countLabel);

    // We find the element where we output the character count
    this.counter = this.label.querySelector('span');

    // Save the node to use it across this module
    this.node = node;

    // Save the text limit for the field
    this.limit = props.countLimit;

    // Count the characters and output information
    this.countAndOutput();

    node.addEventListener('keyup', () => {
      // Count the characters and output information
      this.countAndOutput();
    });
  },

  /**
   * Count characters and output information
   * @return {void}
   */
  countAndOutput() {
    // Get the text length from the input element
    const textLength = this.node.value.length;

    // Output the number of characters entered
    this.counter.textContent = textLength;

    // Get the appropriate class and output it
    this.outputClasses(this.getClasses(textLength));
  },

  /**
   * Get the classes
   * @param {Number} len Text length of the input
   * @return {String}
   */
  getClasses(len) {
    if (len > this.limit) {
      // We're over the limit
      return CLASS_DANGER;
    } else if (len > this.limit * WARNING_LIMIT) {
      // We've hit the warning limit
      return CLASS_WARNING;
    }

    // All is well
    return CLASS_OK;
  },

  /**
   * Output classes on the input element
   * @param {String} cls
   * @return {Void}
   */
  outputClasses(cls) {
    // If this class is already set we can go home
    if (this.label.classList.contains(cls)) {
      return;
    }

    this.label.classList.remove(CLASS_DANGER, CLASS_WARNING, CLASS_OK);

    this.label.classList.add(cls);
  },
};

export default InputCount;
